export function formatPasswordChangedAt(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${hours}:${minutes} / ${day}.${month}.${year}`;
}

export function updatePasswordChangedInfo(changedAt?: string, root?: ParentNode | null): void {
  const scope = root ?? document;
  const statusElements = scope.querySelectorAll<HTMLElement>(
    '.resident-lk-settings__password-status',
  );
  const dateElements = scope.querySelectorAll<HTMLElement>('.resident-lk-settings__password-date');
  const formatted = changedAt ?? formatPasswordChangedAt(new Date());

  statusElements.forEach((el) => {
    el.textContent = 'Изменен';
  });

  dateElements.forEach((el) => {
    el.textContent = formatted;
  });
}
